import { loop } from '/src/scripts/utils/common';

loop('.large-video__video', (video) => {
  video.play();
});
